import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react/require-default-props */
import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';
import DeviceName from 'app/components/DeviceName';
import { hasId } from 'app/util/lookups/createLookup';
import { useDeviceLookup, useDeviceLookupByName } from 'app/util/lookups/deviceIndex';
// Links to a device (or its interface) once it resolves; avoids linking for subtenants (MKP)
const DeviceLink = ({
  $app,
  deviceId,
  name,
  snmp_id,
  showId,
  children,
  ...rest
}) => {
  const {
    data: deviceById
  } = useDeviceLookup(deviceId);
  const {
    data: deviceByName
  } = useDeviceLookupByName(hasId(deviceId) ? undefined : name);
  const linkName = (deviceById ?? deviceByName)?.device_name;
  const label = children ?? /*#__PURE__*/React.createElement(DeviceName, {
    deviceId: deviceId,
    fallbackLabel: name,
    showId: showId
  });

  // loading, not found, not visible, or a subtenant (MKP)
  if (!linkName || $app.isSubtenant) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, label);
  }
  const path = `/v4/infrastructure/devices/${linkName}${snmp_id ? `/interfaces/${snmp_id}` : ''}`;
  return /*#__PURE__*/React.createElement(Link, _extends({
    to: path
  }, rest), label);
};
export default inject('$app')(DeviceLink);